import HospitalChild from './HospitalChild'
export default HospitalChild


// WEBPACK FOOTER //
// ./src/pages/child/hospital/index.js